import { render, staticRenderFns } from "./Asystem.vue?vue&type=template&id=3bdef688&scoped=true"
import script from "./Asystem.vue?vue&type=script&lang=js"
export * from "./Asystem.vue?vue&type=script&lang=js"
import style0 from "./Asystem.vue?vue&type=style&index=0&id=3bdef688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdef688",
  null
  
)

export default component.exports